require('./brokerPensionPlanCancelPendingOrderView.scss');
// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');
const { formatText } = require('core/i18n').i18n;
// @helpers
const PersonalDataHelper = require('utilities/personalDataHelper');

// @components
const OKHeaderCC = require('components/commons/OKHeaderCC/OKHeaderCC');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');

const BrokerPensionPlanCancelPendingOrderStep1 = require('./brokerPensionPlanCancelPendingOrderStep1/brokerPensionPlanCancelPendingOrderStep1');

const VerifyOtpStep = require('components/commons/verifyOtpStep/verifyOtpStep');
const CustomMessageBox = require('components/contactCenter/customMessageBox/customMessageBox');
const PreleaveCancelModal = require('components/contactCenter/preleaveCancelModal/preleaveCancelModal');
// @constants
const { WIZARD_VERTICAL_VIEW_MODE, CHARGE_ACCOUNT_PREFIX } = require('constants/index');
const { BROKER_PENSION_PLAN_CANCEL_PENDING_ORDER } = require('constants/contactCenter/operationTypes');

const translationNamespace = 'cancelPensionPlanPendingOrder';

class BrokerPensionPlanCancelPendingOrderView extends React.Component {
    constructor(props) {
        super(props);
        this.handleShowCancelModal = this.handleShowCancelModal.bind(this);
        this.handleHideCancelModal = this.handleHideCancelModal.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.onHandleGoBack = this.onHandleGoBack.bind(this);
        this.handleValidateStep = this.handleValidateStep.bind(this);
    }

    componentWillUnmount() {
        this.props.reset();
    }

    buildPreleaveCancelModal() {
        const { immBrokerPensionPlanCancelPendingOrder } = this.props;
        const showCancelModal = immBrokerPensionPlanCancelPendingOrder.get('showCancelModal');

        return (
            <PreleaveCancelModal
                isOpen={showCancelModal}
                onCancel={this.handleCancel}
                onCloseModal={this.handleHideCancelModal}
                onStayHere={this.handleHideCancelModal}
            />
        );
    }

    handleShowCancelModal() {
        const { showCancelModal } = this.props;
        showCancelModal(true);
    }

    handleHideCancelModal() {
        const { showCancelModal } = this.props;
        showCancelModal(false);
    }

    handleCancel() {
        const cancelPath = `/myprofile/broker/ordersAndMovements/`;
        this.props.history.push(cancelPath);
    }

    onHandleGoBack() {
        const cancelPath = `/myprofile/broker/ordersAndMovements/`;
        this.props.history.push(cancelPath);
    }

    handleValidateStep(step) {
        const { match: { params: { contractNumber, movementId, detailsIndex } }, validateStep } = this.props;

        validateStep(step, contractNumber, movementId, detailsIndex);
    }

    buildHeader() {
        const title = formatText(`${translationNamespace}-title`);
        const breadcrumpMap = [
            {
                text: formatText('breadcrumb-broker'),
                url: '/myprofile/broker/'
            },
            {
                text: formatText('breadcrumb-ordersAndMovements'),
                url: '/myprofile/broker/ordersAndMovements/'
            },
            {
                text: formatText('breadcrumb-cancelPensionPlanPendingOrder')
            }
        ];

        return (
            <OKHeaderCC
                title={title}
                breadcrumbConfig={breadcrumpMap}
                showBreadBrumb={true}
            />
        );
    }

    handleFinish() {
        const { match: { params: { contractNumber, movementId, detailsIndex } }, cancelPensionPlanPendingOrder } = this.props;
        cancelPensionPlanPendingOrder(contractNumber, movementId, detailsIndex);
    }

    buildSuccessfulFeedback() {
        return (
            <CustomMessageBox
                icon="icon-success"
                title={formatText(`${translationNamespace}-successfulFeedbackTitle`)}
                subtitle={formatText(`${translationNamespace}-successfulFeedbackSubtitle`)}
                textLink={formatText(`${translationNamespace}-feedbackBackButton`)}
                goBackHandler={this.onHandleGoBack}
            />
        );
    }

    buildErrorFeedback() {
        return (
            <CustomMessageBox
                icon="icon-warning"
                title={formatText(`${translationNamespace}-failureFeedbackTitle`)}
                subtitle={formatText(`${translationNamespace}-failureFeedbackSubtitle`)}
                textLink={formatText(`${translationNamespace}-feedbackBackButton`)}
                goBackHandler={this.onHandleGoBack}
            />
        );
    }

    buildWizard() {
        const {
            match: { params: { contractNumber, movementId, detailsIndex } },
            setVisibleStep,
            immBrokerPensionPlanCancelPendingOrder,
            immBrokerContractActivities,
            immProfile
        } = this.props;

        const clientName = PersonalDataHelper.getFullName(immProfile, false);

        const currentStep = immBrokerPensionPlanCancelPendingOrder.get('currentStep');
        const immSteps = immBrokerPensionPlanCancelPendingOrder.get('steps');
        const actions = {
            finish: this.handleFinish,
            setVisibleStep,
            validateStep: this.handleValidateStep,
            setWillCancel: () => { },
            cancel: this.handleShowCancelModal
        }

        const isValidating = immBrokerPensionPlanCancelPendingOrder.get('isValidating');
        const isFetching = immBrokerPensionPlanCancelPendingOrder.get('isFetching')
        const immMovement = immBrokerContractActivities.getIn([contractNumber, 'byId', movementId]);
        const immDetails = immMovement.getIn(['details', 'data', 'listaMovPendientesDet', 'movPendienteDet', detailsIndex]);
        const productNumber = immMovement.get('productNumber');
        const chargeAccount = `${CHARGE_ACCOUNT_PREFIX}${productNumber}${contractNumber}`;
        const amount = immDetails.getIn(['importe', 'importe']);
        const currency = immDetails.getIn(['importe', 'divisa']);
        const operationParams = {
            'ammount': amount,
            'currency': currency,
            'originAccount': chargeAccount
        };

        return (
            <Wizard
                viewMode={WIZARD_VERTICAL_VIEW_MODE}
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={currentStep}
            >

                <WizardStep
                    position="first"
                    cancelButton={true}
                    isLoading={isValidating}
                >
                    <BrokerPensionPlanCancelPendingOrderStep1
                        immBrokerContractActivities={immBrokerContractActivities}
                        contractNumber={contractNumber}
                        movementId={movementId}
                        detailsIndex={detailsIndex}
                        clientName={clientName}
                    />
                </WizardStep>

                <WizardStep
                    position="last"
                    omitPreviousButton={true}
                    cancelButton={true}
                    addLoadingBehaviour={true}
                    isLoading={isFetching}
                    immFinalButton={`${translationNamespace}-confirm`}
                >
                    <VerifyOtpStep
                        operationType={BROKER_PENSION_PLAN_CANCEL_PENDING_ORDER}
                        operationParams={operationParams}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    buildContent() {
        const { immBrokerPensionPlanCancelPendingOrder } = this.props;
        let pageContent;

        if (immBrokerPensionPlanCancelPendingOrder.get('hasBeenFetched')) {
            pageContent = this.buildSuccessfulFeedback();
        } else if (immBrokerPensionPlanCancelPendingOrder.get('error')) {
            pageContent = this.buildErrorFeedback();
        } else {
            const wizard = this.buildWizard();
            const preleaveCancelModal = this.buildPreleaveCancelModal();
            const content = (
                <div className="broker-pension-plan-cancel-pending-order__content col-xs-12">
                    {wizard}
                    {preleaveCancelModal}
                </div>
            );
            pageContent = (
                <div>
                    {content}
                </div>
            );
        }

        return pageContent;
    }

    render() {
        const header = this.buildHeader();
        const content = this.buildContent();

        return (
            <div className="broker-pension-plan-cancel-pending-order">
                {header}
                <div className="broker-pension-plan-cancel-pending-order__body">
                    {content}
                </div>
            </div>

        );
    }
}

BrokerPensionPlanCancelPendingOrderView.propTypes = {
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    immBrokerPensionPlanCancelPendingOrder: PropTypes.object.isRequired,
    immBrokerContractActivities: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    showCancelModal: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    cancelPensionPlanPendingOrder: PropTypes.func.isRequired,
};

module.exports = withRouter(BrokerPensionPlanCancelPendingOrderView);
